
export const translations = {
    table: {
        header:[
            {id:1, label:'ID'},
            {id:2, label:'Subsegmento'},
            {id:3, label:'Orden'},
            {id:4, label:'Segmento'},
            {id:5, label:'Descripción'},
            {id:6, label:'Color'},
            {id:7, label:''},
        ],
        nodata:'No existen subsegmentos registrados'
    },
    modal: {
        add_title:'Agregar subsegmento',
        button:'Agregar',
        form:{
            segment_id:{
                label:'Segmento',
                helperText:'Seleccione una opción'
            },
            name:{
                label:'Nombre',
                helperText:'Este campo debe tener al menos 1 caracter y máximo 255'
            },
            color:{
                label:'Color',
                helperText:'Este campo debe tener al menos 1 caracter y máximo 255'
            },
            description:{
                label:'Descripción',
                helperText:'Este campo debe tener al menos 1 caracter y máximo 255'
            },
            order:{
                label:'Orden',
                helperText:'Seleccione una opción'
            },
            url:{
                label:'Url',
                helperText:'Este campo es obligatorio'
            }
        }
    },
}

